import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RebirthHttpProvider } from 'rebirth-http';
import { I18nClientService } from 'src/app/shared-resources/base-i18n/services/i18n-client.service';
import { DefaultGlobalInterceptor } from 'src/app/shared-resources/interceptors/default-global.interceptor';
import { EnvironmentService } from 'src/app/shared-resources/services/environment.service';
import { UserInfoService } from 'src/app/shared-resources/services/user-info.service';
import { environment } from 'src/environments/environment';
import { LoginService } from './login.service';
/**
 * Service is used for docker externalization.
 */
@Injectable()
export class AppConfig {
  public unAuthoriseErrorCount = 0;
  constructor(
    private http: HttpClient,
    private rebirthHttpProvider: RebirthHttpProvider,
    private defaultInterceptor: DefaultGlobalInterceptor,
    private i18nService: I18nClientService,
    private envService: EnvironmentService,
    private loginService: LoginService,
    private userService: UserInfoService
  ) {}
  load(): Promise<void> {
    const jsonFile = `assets/config/environment.json`;
    return new Promise<void>((resolve, reject) => {
      this.http
        .get(jsonFile)
        .toPromise()
        .then((response: any) => {
          environment.baseUrl = response['baseUrl'];
          environment.declrationApiVersion = response['declrationApiVersion'];
          this.rebirthHttpProvider
            .baseUrl(response['baseUrl'])
            .addResponseErrorInterceptor((err:any) => {
              if (err.status === 401) {
                this.unAuthoriseErrorCount++;
                if (this.unAuthoriseErrorCount === 1 && !window.location.href.includes('login')) {
                  this.userService.userLogout('sessiontimeout');
                }
              } else {
                if (this.unAuthoriseErrorCount > 0) {
                  this.unAuthoriseErrorCount--;
                }
              }
              console.log('Un authorise count ', this.unAuthoriseErrorCount);
            })
            .addInterceptor(this.defaultInterceptor);
          this.envService.setEnvironment(environment);
          this.i18nService.loadResource();
          if (this.loginService.isAuthenticated()) {
            this.loginService
              .userDetails({ username: this.userService.getUserName() })
              .subscribe((res : any) => {
                const token = { accessToken: this.userService.getUserToken() };
                res['token'] = token;
                // console.log(JSON.parse(String(localStorage.getItem('selectedModuleOnRefresh'))))
                // console.log(localStorage.removeItem('selectedModuleOnRefresh'));
                this.loginService.setUserData(
                  res,
                  this.userService.getUserName()
                );
              });
              
          }

          if (environment.botEnable) this.addChatBot();
          resolve();
        })
        .catch(() => {
          reject(`Could not load file environment.json`);
        });
    });
  }

  addChatBot(): void {
    // Bot integration start
    const script = document.createElement('script');
    script.src =
      environment.baseUrl + '/botpress/assets/modules/channel-web/inject.js';
    // script.src = "http://localhost:3000/assets/modules/channel-web/inject.js";
    document.head.appendChild(script);

    setTimeout(() => {
      const scriptBot = document.createElement('script');
      scriptBot.textContent =
        "window.botpressWebChat.init({ host: '" +
        environment.baseUrl +
        "/botpress', botId: 'cargoes', extraStylesheet: '" +
         environment.baseUrl +
         "/assets/css/chatBot.css' })";
      // scriptBot.textContent = "window.botpressWebChat.init({ host: 'http://localhost:3000', botId: 'riise-bot' })";
      document.body.append(scriptBot);
    }, 3000);
    // Bot integration end
  }
}
